import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../auth/AuthContext";
import { maintenanceApi } from "../../api/maintenanceApi";

export default function MaintenanceAlertsWidget() {
  const { token } = useAuth() as { token: string | null };
  const [alertsCount, setAlertsCount] = useState(0);

  useEffect(() => {
    maintenanceApi
      .getDashboard(token)
      .then((d) => setAlertsCount(d.alertsCount ?? 0))
      .catch(() => setAlertsCount(0));
  }, [token]);

  if (alertsCount === 0) return null;

  return (
    <Link
      to="/maintenance"
      className="maintenance-dashboard-alert text-decoration-none d-block mb-3"
    >
      <div className="d-flex align-items-center gap-3 p-3 rounded-3">
        <i className="bi bi-wrench-adjustable-circle-fill maintenance-dashboard-alert-icon" />
        <div className="flex-grow-1">
          <strong>Manutenzione richiesta</strong>
          <div className="small opacity-90">
            {alertsCount} {alertsCount === 1 ? "intervento" : "interventi"} da effettuare
          </div>
        </div>
        <span className="maintenance-dashboard-alert-badge">{alertsCount}</span>
        <i className="bi bi-chevron-right" />
      </div>
    </Link>
  );
}
